import React, { ChangeEvent, FC, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "../../Components/ui/input";
import { Button } from "../../Components/ui/button";
import { CircularProgress, Typography } from "@mui/material";
import { Card } from "src/Components/ui/card";
import SHA256 from "crypto-js/sha256";
import axios from "axios";
//import { toast, ToastContainer } from 'react-toastify';
import { toast, useToast } from "../../Components/ui/use-toast";
import { Toaster } from "../../Components/ui/toaster";
import { Image } from "lucide-react";
import { RootState } from "src/State/store";
import { useDispatch, useSelector } from "react-redux";
import config from "../../config.json";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/Components/ui/dialog";
import { Label } from "../../Components/ui/label";
import {
  Select,
  SelectItem,
  SelectTrigger,
  SelectContent,
  SelectValue,
} from "../../Components/ui/select";
import {
  setworkspace,
  setWorkspaceId,
} from "../../State/slices/AuthenticationSlice";
import {
  setWorkspace_Count,
  triggerRefresh,
} from "../../State/slices/AdvertiserAccountSlice";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from "src/Components/ui/input-otp";
import { TIMER_SETTINGS } from "../../Services/ConfigurationService";

interface Country {
  country_id: number;
  country_name: string;
}
interface Industry {
  industry_id: number;
  industry_name: string;
}
const Workspace_settings: FC = () => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const otpInputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [UserRole, setUserRole] = useState("");
  const mailId = useSelector(
    (state: RootState) => state.authentication.userEmail,
  );
  const workspaceId = useSelector(
    (state: RootState) => state.authentication.workspace_id,
  );
  const [name, setName] = useState("");
  const [Streetname, setStreetName] = useState("");
  const [countrylist, setcountrylist] = useState<Country[]>([]);
  const [industrylist, setindustrylist] = useState<Industry[]>([]);
  const [Streetnumber, setStreetnumber] = useState<number | string>(""); // Can store as number or empty string initially
  const [Code, setCode] = useState<number | string>(""); // Postal Code should be an integer
  const [City, setcity] = useState("");
  const [State, setstate] = useState("");
  const [Country, setcountry] = useState("");
  const [Billing_Country_ISO, setBilling_Country_ISO] = useState("");
  const [Industry, setIndustry] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [fileName, setFileName] = useState<string>("");
  const [base64Image, setBase64Image] = useState("");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [nameError, setnameError] = useState<string | null>(null);
  const [Address, setAddress] = useState("");
  const [StreetNameError, setStreetNameError] = useState<string | null>(null);
  const [StreetNumberError, setStreetNumberError] = useState<string | null>(
    null,
  );
  const [PostalCodeError, setPostalCodeError] = useState<string | null>(null);
  const [CityError, setCityError] = useState<string | null>(null);
  const [StateError, setStateError] = useState<string | null>(null);
  const [CountryError, setCountryError] = useState<string | null>(null);
  const [IndustryError, setIndustryError] = useState<string | null>(null);
  const [WarningMessage, setWarningMessage] = useState<string | null>(null);
  const toast = useToast();
  const accountId = useSelector(
    (state: RootState) => state.authentication.account_id,
  );
  const apiUrlAdvAcc = useSelector(
    (state: RootState) => state.authentication.apiURL,
  );
  const workspace_list = useSelector(
    (state: RootState) => state.advertiserAccount.workspace_list,
  );
  const workspacecount = useSelector(
    (state: RootState) => state.advertiserAccount.workspace_count,
  );
  const wid = useSelector(
    (state: RootState) => state.authentication.workspace_id,
  );
  const [showLastWorkspaceModal, setShowLastWorkspaceModal] = useState(false);
  const [showOTPInput, setShowOTPInput] = useState(false);
  const [otp, setOTP] = useState("");
  const [otpError, setOtpError] = useState("");

  const [canResend, setCanResend] = useState<boolean>(false);
  const apiUrl = useSelector(
    (state: RootState) => state.authentication.authURL,
  );
  // const [apiUrl, setApiUrl] = useState('');
  const isImpersonated = useSelector(
    (state: RootState) => state.admin.Impersonator?.ImpersonationState,
  );
  const impersonatorAID = useSelector(
    (state: RootState) => state.admin.Impersonator?.ImpersonatorAID,
  );

  // Timer state for OTP expiration (default 120 seconds)
  const [timer, setTimer] = useState<number>(TIMER_SETTINGS.INITIAL_TIME);

  // Effect to handle OTP timer countdown
  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;
    if (showOTPInput && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    if (timer === 0) {
      if (interval) clearInterval(interval);
      setShowOTPInput(false); // ✅ goes back to Proceed button screen
      setOTP(""); // ✅ clears OTP input
      setOtpError(""); // ✅ clears OTP error
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [showOTPInput, timer]);

  // Reset timer when OTP input is shown
  useEffect(() => {
    if (showOTPInput) {
      setTimer(TIMER_SETTINGS.INITIAL_TIME);
    }
  }, [showOTPInput]);

  useEffect(() => {
    if (!apiUrlAdvAcc) {
      // Show a toast message when apiUrlAdvAcc is not available
      toast.toast({
        title: "Error",
        description: "Something went wrong. Please try again.",
        duration: 3000, // Show for 3 seconds
      });
      return; // Prevent further execution if the URL is missing
    } // Prevent early API calls
    GetWorkspaceDetailsByID();
    // getcountrylist();
    getindustrylist();
  }, [apiUrlAdvAcc]); // Runs when apiUrlAdminAcc is updated

  useEffect(() => {
    if (mailId && workspaceId) {
      GetRoleNameByEmailAndWorkspace();
    }
  }, [mailId, workspaceId]);

  const GetRoleNameByEmailAndWorkspace = () => {
    setIsLoading(true);
    if (!mailId || !workspaceId || !apiUrlAdvAcc) {
      return; // Prevent API call if data is missing
    }

    axios
      .post(`${apiUrlAdvAcc}/GetRoleNameByEmailAndWorkspace`, {
        email: mailId,
        workspaceInfoId: workspaceId,
      })
      .then((response) => {
        const firstItem = response.data?.[0];
        if (firstItem?.Status === "Success") {
          setUserRole(firstItem.Role_Name);
        }
      })
      .catch((error) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };

  const dispatch = useDispatch();
  // const [apiUrlAdvAcc, setApiUrlAdvAcc] = useState("");
  const workspace_id = useSelector(
    (state: RootState) => state.authentication.workspace_id,
  );

  const getcountrylist = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${apiUrlAdvAcc}/GetCountryList`);
      if (response.data.status === "Success") {
        setcountrylist(response.data.countryList as Country[]); // Safeguard for empty array
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };
  const getindustrylist = async () => {
    setIsLoading(true);
    // debugger;
    try {
      const response = await axios.get(`${apiUrlAdvAcc}/GetIndustryList `);
      if (response.data.status === "Success") {
        setindustrylist(response.data.industryList as Industry[]); // Safeguard for empty array
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleStreetNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // Check if the value contains only numbers
    const regex = /^[0-9]*$/;
    // Check if the length is <= 10 (or any other number you prefer)
    if (!regex.test(value)) {
      setStreetNumberError("Street number can only contain numbers.");
    } else if (value.length > 10) {
      setStreetNumberError("Street number cannot be longer than 10 digits.");
    } else {
      setStreetNumberError(""); // Clear the error when the input is valid
      setStreetnumber(value);
    }
  };

  const handlePostalCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // Check if the value contains only numbers
    const regex = /^[0-9]*$/;

    // Check if the length is <= 10 (or any other number you prefer)
    if (!regex.test(value)) {
      setPostalCodeError("Postal code can only contain numbers.");
    } else if (value.length > 6) {
      setPostalCodeError("Postal number cannot be longer than 6 digits.");
    } else {
      setPostalCodeError(""); // Clear the error when the input is valid
      setCode(value);
    }
  };

  const handleStreetNameChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    const nameRegex = /^[A-Za-z]+(?:\s[A-Za-z]+)*$/;

    if (!value) {
      setStreetNameError("Please fill the field.");
    } else if (!nameRegex.test(value)) {
      setStreetNameError("Name must contain only letters.");
    } else {
      setStreetNameError("");
    }

    setStreetName(value);
  };

  // Handle City input change with validation (only letters)
  const handleCityChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const regex = /^[A-Za-z]+(?:\s[A-Za-z]+)*$/; // Allow only letters and spaces

    if (!regex.test(value)) {
      setCityError("City name can only contain letters and spaces.");
    } else {
      setCityError(""); // Clear the error when the input is valid
    }
    setcity(value);
  };

  // Handle State input change with validation (only letters)
  const handleStateChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const regex = /^[A-Za-z]+(?:\s[A-Za-z]+)*$/; // Allow only letters and spaces

    if (!regex.test(value)) {
      setStateError("State name can only contain letters and spaces.");
    } else {
      setStateError("");
    }
    setstate(value);
  };

  const handleCompanyNameChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (!value.trim()) {
      setnameError("Please fill the field.");
      setName(value);
      return;
    }

    // First character should NOT be a special character (letters & numbers allowed)
    const firstChar = value.charAt(0);
    const firstCharRegex = /^[a-zA-Z0-9]/; // Allows letters and numbers

    // Last character should NOT be a special character (letters & numbers allowed)
    const lastChar = value.charAt(value.length - 1);
    const lastCharRegex = /^[a-zA-Z0-9]$/; // Allows letters and numbers

    // Ensure spaces are allowed in between but not at the start or end
    if (!firstCharRegex.test(firstChar)) {
      setnameError("First character should not be a special character.");
    } else if (!lastCharRegex.test(lastChar)) {
      setnameError(
        "Last character should not be a special character or empty space.",
      );
    } else {
      setnameError("");
    }

    setName(value);
  };

  const handleProfileUpdate = async () => {
    setIsLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    toast.toast({
      title: "Success",
      description: "Profile updated successfully",
      duration: 3000,
    });

    setIsLoading(false);
  };

  const sample = async () => {
    setIsLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    toast.toast({
      title: "Success",
      description: "Profile updated successfully",
      duration: 3000,
    });

    setIsLoading(false);
  };

  const UpdateWorkspaceAddress = async () => {
    if (
      StreetNameError ||
      StreetNumberError ||
      PostalCodeError ||
      CityError ||
      StateError
    ) {
      return;
    }

    if (!Streetname || !Streetnumber || !Code || !City || !State || !Country) {
      setWarningMessage("Please fill in all the fields before submitting.");
      return; // Prevent form submission or API call
    } else {
      setWarningMessage("");
    }
    if (!Country) {
      setCountryError("Please select a country before submitting.");
      return; // Prevent form submission or API call
    } else {
      setCountryError("");
    }

    setIsLoading(true);
    axios
      .put(`${apiUrlAdvAcc}/updateWorkSpaceAddress`, {
        accountId: accountId,
        workspaceid: workspace_id,
        streetName: Streetname || "",
        streetNumber: String(Streetnumber) || "",
        city: City || "",
        postalCode: String(Code) || "",
        state: State || "",
        // "country": Country || "",
        // "billingCountry": Billing_Country_ISO || ""
        ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
      })

      .then((response) => {
        if (response.data.status === "Success") {
          toast.toast({
            title: "Success",
            description: "Company Address Updated Successfully",
            duration: 3000,
          });

          setTimeout(() => {}, 3000);
        } else {
          toast.toast({
            title: "Error",
            description: "Company Address Update Failed",
            duration: 3000,
          });
        }
      })
      .catch((error) => {
        toast.toast({
          title: "Error",
          description: "Company Address Update Failed",
          duration: 3000,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const GetWorkspaceDetailsByID = async () => {
    axios
      .post(`${apiUrlAdvAcc}/GetWorkspaceDetailsByWorkspaceID`, {
        workspaceId: workspace_id, // Email ID for the user
      })
      .then((response) => {
        if (response.data.length > 0 && response.data[0].Status === "Success") {
          const Workspace_Name = response.data[0].Workspace_Name;
          const Billing_Country_Name = response.data[0].Billing_Country_Name;
          const workspace_industry = response.data[0].Workspace_Industry;
          const address = response.data[0].Address; // Corrected case
          const Billing_Country_ISO = response.data[0].Billing_Country_ISO;

          // Update main details
          setName(Workspace_Name);
          setcountry(Billing_Country_Name);
          setIndustry(workspace_industry);
          setAddress(address);
          setBilling_Country_ISO(Billing_Country_ISO);

          // Parse and update address details
          if (address) {
            try {
              const parsedAddress = JSON.parse(address);
              setStreetName(parsedAddress.street_name || "");
              setStreetnumber(parsedAddress.street_number || "");
              setCode(parsedAddress.postal_code || "");
              setcity(parsedAddress.city || "");
              setstate(parsedAddress.state || "");
            } catch (error) {}
          }
        }
      })
      .catch((error) => {});
  };

  const UpdateWorkSpaceIndustry = async () => {
    if (!Industry) {
      setIndustryError("Please select a Industry before submitting.");
      return; // Prevent form submission or API call
    }
    setIsLoading(true);
    axios
      .put(`${apiUrlAdvAcc}/updateWorkspaceIndustry`, {
        accountId: accountId,
        workspaceid: workspace_id,
        workspaceIndustry: Industry,
        ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
      })

      .then((response) => {
        if (response.data.status === "Success") {
          toast.toast({
            title: "Success",
            description: "Company Industry Updated successfully",
            duration: 3000,
          });

          setTimeout(() => {}, 3000);
        } else {
          toast.toast({
            title: "Error",
            description: "Company Industry Update Failed",
            duration: 3000,
          });
        }
      })
      .catch((error) => {
        toast.toast({
          title: "Error",
          description: "Company Industry Update Failed",
          duration: 3000,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleCompanyUpdate = async () => {
    if (nameError) {
      return;
    }
    setIsLoading(true);
    axios
      .put(`${apiUrlAdvAcc}/UpdateWorkSpaceName`, {
        accountId: accountId,
        workspaceId: workspace_id,
        newWorkspaceName: name,
        ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
      })

      .then((response) => {
        if (response.data.status === "Success") {
          toast.toast({
            title: "Success",
            description: "Company name Updated Successfully",
            duration: 3000,
          });
          dispatch(setworkspace(name));
          dispatch(triggerRefresh("workspaceList")); // ✅ refresh dropdown
          setTimeout(() => {}, 3000);
        } else {
          toast.toast({
            title: "Error",
            description: "Company name Update Failed",
            duration: 3000,
          });
        }
      })
      .catch((error) => {
        toast.toast({
          title: "Error",
          description: "Company name Update Failed",
          duration: 3000,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    const id = localStorage.getItem("userid");
    // handleCompanyUpdate();
    // setName(name);
  }, []);

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };
  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) {
      setFileName("");
      setErrorMessage("No file selected.");
      setTimeout(() => setErrorMessage(null), 3000);
      return;
    }

    const validFileTypes = ["image/jpeg", "image/png"];
    const maxFileSize = 5 * 1024 * 1024;

    const dotCount = (file.name.match(/\./g) || []).length;
    if (dotCount > 1) {
      setFileName("");
      setErrorMessage("Invalid file name");
      return;
    }

    if (!validFileTypes.includes(file.type)) {
      setErrorMessage("Please select a valid image (PNG or JPEG).");
      // setTimeout(() => setErrorMessage(null), 3000);
      setFileName("");
      return;
    } else {
      setErrorMessage("");
    }

    if (file.size > maxFileSize) {
      setErrorMessage("File size should not exceed 5MB.");
      // setTimeout(() => setErrorMessage(null), 3000);
      setFileName("");
      return;
    } else {
      setErrorMessage("");
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new window.Image();
      img.onload = () => {
        if (img.width < 400 || img.height < 400) {
          setErrorMessage("Image dimensions must be at least 400x400 pixels.");
          // setTimeout(() => setErrorMessage(null), 3000);
          setFileName("");
        } else {
          // Valid image
          // setSuccessMessage("Image uploaded successfully!");
          // setTimeout(() => setSuccessMessage(null), 3000);
          setErrorMessage("");
          setFileName(file.name);
          // Convert image to Base64
          const base64String = reader.result?.toString().split(",")[1]; // Remove metadata
          setBase64Image(base64String || "");
        }
      };
      img.onerror = () => {
        setErrorMessage("Invalid image file.");
        setTimeout(() => setErrorMessage(null), 3000);
        setFileName("");
      };
      img.src = e.target?.result as string;
    };
    reader.readAsDataURL(file);
  };

  const handleUpdateImage = async () => {
    setIsLoading(true);
    const mappingId = workspace_id;

    if (!mappingId) {
      toast.toast({
        title: "Error",
        description: "Could not retrieve user personal ID.",
        duration: 3000,
      });
      return;
    }

    if (!base64Image) {
      setErrorMessage("No valid image selected.");
      setIsLoading(false);
      return;
    }

    try {
      const response = await axios.put(
        `${apiUrlAdvAcc}/UpdateLogo_workspace_id`,
        {
          CreatedBy: accountId,
          MappingId: mappingId,
          Image: base64Image,
          UpdatedBy: workspace_id,
          UpdatedDate: new Date(),
          CreatedDate: new Date(),
          ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
        },
      );

      if (response.data.status === "Success") {
        toast.toast({
          title: "Success",
          description: "Logo updated successfully.",
          duration: 3000,
        });

        dispatch(triggerRefresh("workspaceList")); // ✅ refresh dropdown

        setFileName("");
        setBase64Image("");
        setErrorMessage("");
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else {
        toast.toast({
          title: "Error",
          description: "Failed to update logo.",
          duration: 3000,
        });
      }
    } catch (error) {
      toast.toast({
        title: "Error",
        description: "An error occurred while updating the logo.",
        duration: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpen = () => {
    setIsAlertOpen(true);
  };

  const sendOTP = async () => {
    setIsLoading(true);
    try {
      debugger;
      const response = await axios.post(`${apiUrl}/SendOtp/SendOtp`, {
        Email: mailId,
      });
      if (response.status === 200 && response.data.status === "Success") {
        toast.toast({
          title: "Success",
          description: response.data.message || "OTP sent to your email.",
          duration: 3000,
        });
        setShowOTPInput(true);
        setTimer(TIMER_SETTINGS.INITIAL_TIME); // Reset timer to 120 seconds
        setCanResend(false); // Disable resend until timer expires
      } else {
        toast.toast({
          title: "Error",
          description: response.data.message || "Failed to send OTP.",
          duration: 3000,
        });
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.toast({
        title: "Error",
        description: "An error occurred while sending OTP.",
        duration: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  function hashOtp(otp: string): string {
    return SHA256(otp).toString();
  }

  const verifyOTPAndDeleteAccount = async () => {
    if (otp.length !== 6 || !/^[0-9]{6}$/.test(otp)) {
      // setOtpError("OTP must be a 6-digit number.");
      return;
    }
    if (timer <= 0) {
      toast.toast({
        title: "Time Expired",
        description: "Time expired. Please click Resend OTP.",
      });
      setOTP("");
      return;
    }
    if (!apiUrl) {
      toast.toast({
        title: "Error",
        description: "API URL is not configured. Please try again.",
      });
      return;
    }
    setIsLoading(true);
    try {
      const hashedOtp = hashOtp(otp);
      console.log(
        "Sending OTP verification request to:",
        `${apiUrl}/VerifyOtp`,
      ); // Debug log
      console.log("Payload:", { Email: mailId, Otp: hashedOtp }); // Debug log
      const response = await axios.post(`${apiUrl}/VerifyOtp`, {
        Email: mailId,
        Otp: hashedOtp,
      });
      debugger;
      //     if (response.status === 200 && response.data.status === "Success") {
      //       const deleteResponse = await axios.get(
      //         `${apiUrlAdvAcc}/DeleteWorkspaceforsettings?workspaceid=${workspace_id}&accountId=${accountId}`
      //       );
      //       debugger
      //       if (
      //         deleteResponse.status === 200 &&
      //         deleteResponse.data?.status === "Success"
      //       ) {
      //         const desc = deleteResponse.data.status_description || "";

      //         if (
      //           desc.includes("Validation failed") ||
      //           desc.includes("not allowed")
      //         ) {
      //           // ❌ Deletion blocked
      //           toast.toast({
      //             title: "Deletion not allowed",
      //             description: desc,
      //             duration: 3000,
      //           });
      //           setIsAlertOpen(false);
      //         } else if (desc.includes("deleted successfully")) {
      //           // ✅ Account deleted
      //           toast.toast({
      //             title: "Success",
      //             description: "Your account has been deleted successfully.",
      //             duration: 3000,
      //           });

      //           sessionStorage.removeItem("lastFetchedWorkspaceCount");
      //           dispatch(setWorkspace_Count(0));
      //           dispatch(setWorkspaceId(0));
      //           dispatch(setworkspace(""));
      //           setShowLastWorkspaceModal(false);
      //           setShowOTPInput(false);
      //           setOTP("");
      //           setOtpError("");

      //           setTimeout(() => {
      //             navigate("/");
      //           }, 1000); // ⏳ waits 1 second before navigating
      //         } else {
      //         }
      //       } else {
      //         toast.toast({
      //           title: "Error",
      //           description: "Failed to delete account.",
      //           duration: 3000,
      //         });
      //       }
      //     } else {
      //       setOtpError("Invalid OTP. Please try again.");
      //     }
      //   } catch (error) {
      //     console.error("Error during OTP verification:", error);
      //     toast.toast({
      //       title: "Error",
      //       description:
      //         "An error occurred while verifying OTP or deleting account.",
      //       duration: 3000,
      //     });
      //     setOTP("");
      //   } finally {
      //     setIsLoading(false);
      //   }
      // };

      if (response.status === 200 && response.data.status === "Success") {
        const deleteResponse = await axios.get(
          `${apiUrlAdvAcc}/DeleteWorkspaceforsettings?workspaceid=${workspace_id}&accountId=${accountId}`,
        );
        debugger;
        if (
          deleteResponse.status === 200 &&
          deleteResponse.data?.status === "Success"
        ) {
          const desc = deleteResponse.data.status_description || "";

          if (
            desc.includes("Validation failed") ||
            desc.includes("not allowed")
          ) {
            // ❌ Deletion blocked
            toast.toast({
              title: "Deletion not allowed",
              description: desc,
              duration: 3000,
            });
            setIsAlertOpen(false);
          } else if (desc.includes("deleted successfully")) {
            // ✅ Account deleted
            toast.toast({
              title: "Success",
              description: "Your account has been deleted successfully.",
              duration: 3000,
            });

            sessionStorage.removeItem("lastFetchedWorkspaceCount");
            dispatch(setWorkspace_Count(0));
            dispatch(setWorkspaceId(0));
            dispatch(setworkspace(""));
            setShowLastWorkspaceModal(false);
            setShowOTPInput(false);
            setOTP("");
            setOtpError("");

            setTimeout(() => {
              navigate("/");
            }, 1000); // ⏳ waits 1 second before navigating
          } else {
          }
        } else if (
          deleteResponse.status === 200 &&
          deleteResponse.data?.status === "Error" // ✅ ADDED
        ) {
          const desc = deleteResponse.data.status_description || "";
          toast.toast({
            title: "Deletion not allowed",
            description: desc,
            duration: 3000,
          });
          setTimeout(() => {
            setShowLastWorkspaceModal(false); // ✅ closes OTP dialog
            setShowOTPInput(false); // ✅ resets OTP input
            setOTP(""); // ✅ clears OTP value
            setOtpError(""); // ✅ clears OTP error
          }, 100);
        } else {
          toast.toast({
            title: "Error",
            description: "Failed to delete account.",
            duration: 3000,
          });
        }
      } else {
        setOtpError("Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error during OTP verification:", error);
      toast.toast({
        title: "Error",
        description:
          "An error occurred while verifying OTP or deleting account.",
        duration: 3000,
      });
      setOTP("");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setIsAlertOpen(false);
  };

  // const token = localStorage.getItem('token');

  const handleAccountDeletion = async () => {
    setIsLoading(true);

    // Get the next available workspace_id (other than the given one)
    const nextWorkspace = workspace_list.find((ws) => ws.workspace_id !== wid);
    let newwid: number;
    let newworkspaceName: string;
    if (nextWorkspace) {
      newwid = nextWorkspace.workspace_id;
      newworkspaceName = nextWorkspace.workspace_name;
    }
    debugger;
    try {
      const response = await axios.get(
        `${apiUrlAdvAcc}/DeleteWorkspaceforsettings?workspaceid=${workspace_id}&accountId=${accountId}`,
      );

      // if (response.status === 200) {
      //   setIsLoading(false);
      //   toast.toast({
      //     title: "Success",
      //     description: "Your Workspace has been deleted!",
      //     duration: 1000,
      //   });

      //   sessionStorage.removeItem("lastFetchedWorkspaceCount");
      //   dispatch(setWorkspace_Count(workspacecount - 1));

      //   setTimeout(() => {
      //     dispatch(setWorkspaceId(newwid ? newwid : 0));
      //     dispatch(setworkspace(newworkspaceName ? newworkspaceName : ""));
      //     newwid ?
      //       navigate("/navbar/dashboard/") :
      //       navigate("/");
      //   }, 1000);
      // }
      //     if (response.status === 200 && response.data?.status === "Success") {
      //       setIsLoading(false);

      //       if (
      //         response.data.status_description?.includes("Validation failed") ||
      //         response.data.status_description?.includes("not allowed") ||
      //         response.data.status_description?.includes("cannot be deleted")
      //       ) {
      //         // ❌ Deletion blocked
      //         toast.toast({
      //           title: "Deletion not allowed",
      //           description: response.data.status_description,
      //           duration: 2000,
      //         });
      //       } else if (
      //         response.data.status_description?.includes(
      //           "Workspace deleted successfully"
      //         )
      //       ) {
      //         // ✅ Deleted
      //         toast.toast({
      //           title: "Success",
      //           description: "Your Workspace has been deleted!",
      //           duration: 1000,
      //         });

      //         sessionStorage.removeItem("lastFetchedWorkspaceCount");
      //         dispatch(setWorkspace_Count(workspacecount - 1));

      //         setTimeout(() => {
      //           dispatch(setWorkspaceId(newwid ? newwid : 0));
      //           dispatch(setworkspace(newworkspaceName ? newworkspaceName : ""));
      //           newwid ? navigate("/navbar/dashboard/") : navigate("/");
      //         }, 1000);
      //       }
      //        else {
      //         // ⚠️ Some other message
      //         toast.toast({
      //           title: "Info",
      //           description: response.data.status_description,
      //           duration: 2000,
      //         });
      //       }
      //     }
      //   } catch (error) {
      //     setIsLoading(false);
      //     toast.toast({
      //       title: "Failed",
      //       description: "Error in Deletion",
      //       duration: 3000,
      //     });
      //   } finally {
      //     handleClose(); // Ensures handleClose() runs after the API call
      //   }
      // };
      if (response.status === 200 && response.data?.status === "Success") {
        setIsLoading(false);

        if (
          response.data.status_description?.includes("Validation failed") ||
          response.data.status_description?.includes("not allowed") ||
          response.data.status_description?.includes("cannot be deleted")
        ) {
          // ❌ Deletion blocked
          toast.toast({
            title: "Deletion not allowed",
            description: response.data.status_description,
            duration: 2000,
          });
        } else if (
          response.data.status_description?.includes(
            "Workspace deleted successfully",
          )
        ) {
          // ✅ Deleted
          toast.toast({
            title: "Success",
            description: "Your Workspace has been deleted!",
            duration: 1000,
          });

          sessionStorage.removeItem("lastFetchedWorkspaceCount");
          dispatch(setWorkspace_Count(workspacecount - 1));

          setTimeout(() => {
            dispatch(setWorkspaceId(newwid ? newwid : 0));
            dispatch(setworkspace(newworkspaceName ? newworkspaceName : ""));
            newwid ? navigate("/navbar/dashboard/") : navigate("/");
          }, 1000);
        } else {
          // ⚠️ Some other message
          toast.toast({
            title: "Info",
            description: response.data.status_description,
            duration: 2000,
          });
        }
      } else if (response.status === 200 && response.data?.status === "Error") {
        // ✅ ADDED
        setIsLoading(false);
        toast.toast({
          title: "Deletion not allowed",
          description: response.data.status_description,
          duration: 3000,
        });
      }
    } catch (error) {
      setIsLoading(false);
      toast.toast({
        title: "Failed",
        description: "Error in Deletion",
        duration: 3000,
      });
    } finally {
      handleClose(); // Ensures handleClose() runs after the API call
    }
  };

  const confirmDelete = () => {
    handleAccountDeletion(); //
  };

  return (
    <div className="flex h-screen">
      {/* Loading Overlay */}
      {isLoading && (
        <div className="absolute inset-0 bg-gray-500/50 flex items-center justify-center z-50">
          <CircularProgress className="text-primary" />
        </div>
      )}

      <div className="flex-grow ml-0 p-2 overflow-y-auto ">
        <Toaster />
        {/* Comapany logo */}
        <Card className="mb-8 p-6 border border-grey text-left max-w-xl ">
          <Typography
            component="h2"
            className=" mb-4"
            style={{
              fontWeight: 600,
              fontSize: "14px",
              paddingBottom: "6px",
              lineHeight: "24px",
              color: "#020617",
            }}
          >
            <b>Company logo</b>
          </Typography>
          <Typography
            className="mb-4 mt-1"
            style={{
              fontSize: "14px",
              fontWeight: 400,
              color: "#64748B",
              lineHeight: "24px",
            }}
          >
            Update your team's logo to make it easier to identify
          </Typography>

          <div
            className="flex items-center gap-2 mt-4 cursor-pointer"
            onClick={() => document.getElementById("file-upload")?.click()}
          >
            <div className="flex-col">
              <div className="flex gap-2">
                <Input
                  type="text"
                  value={fileName}
                  readOnly
                  className="flex-grow w-[100%] border-[#E2E8F0] placeholder-[#64748B]"
                  placeholder="No file chosen"
                  style={{ fontWeight: 500 }}
                />
                <Button
                  type="button"
                  onClick={handleUploadClick}
                  className="font-medium text-[14px] bg-[#F1F5F9] w-[50%] text-[#0F172A] hover:bg-gray-300 focus:ring-[#F1F5F9]  mt--1"
                  style={{
                    height: "2.2rem",
                    padding: "0 0.5rem",
                    fontSize: "0.8rem",
                  }}
                >
                  Upload image
                </Button>
              </div>
              {/* Error and Success Messages */}
              {errorMessage && (
                <Typography
                  className="font-sans italic"
                  style={{ color: "red", fontSize: "12px", marginTop: "8px" }}
                >
                  {errorMessage}
                </Typography>
              )}
              <p
                className="text-sm text-gray-500 mt-2"
                style={{
                  textAlign: "left",
                  fontSize: "13px",
                  color: "#64748B",
                  marginBottom: "2px",
                }}
              >
                * .png, * .jpeg files up to 5MB at least 400px by 400px
              </p>
            </div>
            <input
              ref={fileInputRef}
              id="companyLogo"
              type="file"
              accept="image/*"
              className="sr-only"
              onChange={handleImageUpload}
            />
          </div>
          <Button
            onClick={handleUpdateImage}
            disabled={isLoading}
            className="py-1 px-3 text-sm w-[128px] mt-1"
            style={{ fontWeight: 400, fontSize: "14px" }}
          >
            {isLoading ? "Updating..." : "Update image"}
          </Button>
        </Card>

        {/* Profile Information Section */}
        <Card className="mb-8 p-6 border border-grey text-left max-w-xl">
          <Typography
            component="h3"
            className="mb-4"
            style={{
              fontWeight: 600,
              fontSize: "14px",
              paddingBottom: "6px",
              color: "#020617",
            }}
          >
            <b>Company name</b>
          </Typography>
          <Typography
            component="p"
            className="mb-4"
            style={{ fontSize: "14px", fontWeight: 400, color: "#64748B" }}
          >
            Update your team's name
          </Typography>
          <Input
            className="mb-[-2] mt-6 text-[#020617] text-[14px] font-normal"
            value={name}
            // onChange={(e) => setName(e.target.value)}
            onChange={handleCompanyNameChange}
            placeholder="Your name"
            aria-label="Your name"
          />
          {nameError && (
            <p className="text-red-500 text-xs font-medium mt-1 mb-2 font-sans italic ml-1">
              {nameError}
            </p>
          )}
          <Button
            onClick={handleCompanyUpdate}
            disabled={isLoading}
            className="py-1 px-3 text-sm w-[35%] mt-4"
            style={{ fontWeight: 500, fontSize: "14px", color: "#F8FCFC" }}
          >
            {isLoading ? "Updating..." : "Update Company Name"}
          </Button>
        </Card>

        {/* Update Email Section */}
        <Card className="mb-8 p-6 border border-grey text-left max-w-xl">
          <Typography
            component="h3"
            className="mb-4"
            style={{
              fontWeight: 600,
              fontSize: "14px",
              paddingBottom: "6px",
              color: "#020617",
            }}
          >
            <b>Company address</b>
          </Typography>
          <Typography
            component="p"
            className="mb-4"
            style={{ fontSize: "14px", fontWeight: 400, color: "#64748B" }}
          >
            Update your company address
          </Typography>
          {WarningMessage && (
            <p className="text-red-500 text-xs font-medium mt-1 font-sans italic text-left ">
              {WarningMessage}
            </p>
          )}

          <div className="mb-4 mt-4 space-y-4">
            <div>
              <Label htmlFor="streetName">Street name</Label>
              <Input
                id="streetName"
                className="mt-2"
                value={Streetname}
                onChange={handleStreetNameChange}
                aria-label="Street name"
              />
              {StreetNameError && (
                <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                  {StreetNameError}
                </p>
              )}
            </div>

            <div>
              <Label htmlFor="streetNumber">Street number</Label>
              <Input
                id="streetNumber"
                className="mt-2"
                value={Streetnumber}
                onChange={handleStreetNumberChange}
                aria-label="Street number"
              />
              {StreetNumberError && (
                <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                  {StreetNumberError}
                </p>
              )}
            </div>

            <div>
              <Label htmlFor="city">City</Label>
              <Input
                id="city"
                className="mt-2"
                value={City}
                onChange={handleCityChange}
                aria-label="City"
              />
              {CityError && (
                <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                  {CityError}
                </p>
              )}
            </div>

            <div>
              <Label htmlFor="postalCode">Postal code</Label>
              <Input
                id="postalCode"
                className="mt-2"
                value={Code}
                onChange={handlePostalCodeChange}
                aria-label="Postal Code"
              />
              {PostalCodeError && (
                <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                  {PostalCodeError}
                </p>
              )}
            </div>

            <div>
              <Label htmlFor="state">State</Label>
              <Input
                id="state"
                className="mt-2"
                value={State}
                required
                onChange={handleStateChange}
                aria-label="State"
              />
              {StateError && (
                <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                  {StateError}
                </p>
              )}
            </div>

            <div>
              <Label htmlFor="billingcountry">Billing country</Label>
              <Input
                id="billingcountry"
                value={Country}
                disabled
                className="mt-2 w-full border-gray-400 rounded-[7px]"
              />
              {CountryError && (
                <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                  {CountryError}
                </p>
              )}
            </div>
          </div>
          <Button
            onClick={UpdateWorkspaceAddress}
            disabled={isLoading}
            className="py-1 px-3 text-sm w-[204px] mt-4"
            style={{ fontWeight: 500, fontSize: "14px", color: "#F8FCFC" }}
          >
            {isLoading ? "Updating..." : "Update Company address"}
          </Button>
        </Card>

        <Card className="mb-8 p-6 border border-grey text-left max-w-xl">
          <Typography
            component="h3"
            className="mb-4"
            style={{
              fontWeight: 600,
              fontSize: "14px",
              paddingBottom: "6px",
              color: "#020617",
            }}
          >
            <b>Company industry</b>
          </Typography>
          <Typography
            component="p"
            className="mb-4"
            style={{ fontSize: "14px", fontWeight: 400, color: "#64748B" }}
          >
            We collect this information for analytics and to provide more
            accurate guidance for your account.
          </Typography>

          <Select
            value={Industry}
            onValueChange={(value) => {
              setIndustry(value); // Update state with the selected value
            }}
          >
            <SelectTrigger className="text-gray-500 mt-4 text-left w-full p-2 border border-gray-300 rounded">
              <SelectValue
                className="text-gray-500"
                placeholder="Select Industry"
              />
            </SelectTrigger>
            <SelectContent>
              {industrylist.map((industry) => (
                <SelectItem
                  className="cursor-pointer"
                  key={industry.industry_id}
                  value={industry.industry_name}
                >
                  {industry.industry_name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {IndustryError && (
            <Typography className="text-red-500 mb-4">
              {IndustryError}
            </Typography>
          )}
          <Button
            onClick={UpdateWorkSpaceIndustry}
            disabled={isLoading}
            className="py-1 px-3 text-sm w-[140px]"
            style={{ fontWeight: 500, fontSize: "14px", color: "#F8FCFC" }}
          >
            {isLoading ? "Updating..." : "Update Industry"}
          </Button>
        </Card>

        {/* Delete Account Section */}
        <Card className="mb-8 p-6 border border-grey text-left max-w-xl border-2 border-red-600">
          <Typography
            component="h3"
            className="mb-4"
            style={{
              fontWeight: 600,
              fontSize: "14px",
              lineHeight: "24px",
              color: "#020617",
              letterSpacing: "-1.5%",
              paddingBottom: "6px",
            }}
          >
            {" "}
            Danger zone
          </Typography>
          <Typography
            component="p"
            className="mb-4"
            style={{
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "20px",
              color: "#64748B",
            }}
          >
            Some actions cannot be undo. Please be careful.
          </Typography>
          <Typography
            component="h3"
            className="mb-4"
            style={{
              fontWeight: 600,
              fontSize: "14px",
              lineHeight: "24px",
              color: "#020617",
              letterSpacing: "-1.5%",
              paddingBottom: "6px",
            }}
          >
            Delete team
          </Typography>
          <Typography
            component="p"
            className="mb-4"
            style={{
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "20px",
              color: "#64748B",
            }}
          >
            This action cannot be undone. All data associated with this team
            will be deleted.
          </Typography>
          <Button
            onClick={() => {
              if (
                UserRole === "Primary Owner" ||
                UserRole === "Primary Advertiser"
              ) {
                if (workspacecount === 1) {
                  setShowLastWorkspaceModal(true); // Show single workspace modal
                } else {
                  setIsAlertOpen(true); // Show existing dialog for multiple workspaces
                }
              } else {
                toast.toast({
                  title: "Access denied",
                  description:
                    "Access denied. You are not a Primary Advertiser.",
                  duration: 3000,
                });
              }
            }}
            // onClick={handleAccountDeletion}
            className="bg-[#EF4444] text-white py-2 px-4 text-sm hover:bg-red-700 w-[167px]"
          >
            <span
              style={{ fontWeight: 500, fontSize: "14px", color: "#F8FCFC" }}
            >
              {" "}
              Delete your workspace{" "}
            </span>
          </Button>

          <Dialog
            open={isAlertOpen}
            onOpenChange={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent className="max-w-xl ">
              <DialogHeader>
                <DialogTitle className="text-18px font-semibold text-[#09090B] mb-2">
                  Delete Workspace
                </DialogTitle>
                <DialogDescription className="text-14px font-medium text-[#71717A]">
                  {isImpersonated
                    ? "You are currently in impersonation mode. The delete option is not available while impersonating an account."
                    : "If you delete your workspace, all associated data will also be permanently deleted. Do you want to proceed?"}
                </DialogDescription>
              </DialogHeader>

              {!isImpersonated && (
                <div className="flex justify-end gap-4">
                  <Button
                    disabled={isLoading}
                    variant="outline"
                    className="px-4 py-2 w-24"
                    onClick={handleClose}
                    autoFocus
                  >
                    Cancel
                  </Button>
                  <Button
                    className="px-4 py-2 w-24 bg-[#EF4444]"
                    onClick={confirmDelete}
                  >
                    {isLoading ? "Deleting..." : "OK"}
                  </Button>
                </div>
              )}
            </DialogContent>
          </Dialog>

          <Dialog
            open={showLastWorkspaceModal}
            onOpenChange={() => setShowLastWorkspaceModal(false)}
          >
            <DialogContent className="max-w-xl">
              <DialogHeader>
                <DialogTitle className="text-lg font-semibold text-[#09090B] mb-2">
                  Delete Your Workspace
                </DialogTitle>
                <DialogDescription className="text-sm font-medium text-[#71717A]">
                  {isImpersonated ? (
                    "You are currently in impersonation mode. The delete option is not available while impersonating an account."
                  ) : (
                    <>
                      This action will permanently remove both your workspace
                      and associated account. As this action is irreversible,
                      OTP verification is required.
                      {!showOTPInput && (
                        <>
                          <br />
                          Click to "Proceed"
                        </>
                      )}
                    </>
                  )}
                </DialogDescription>
              </DialogHeader>

              {!showOTPInput ? (
                !isImpersonated && (
                  <div className="flex justify-end gap-4 mt-2">
                    <Button
                      variant="outline"
                      className="w-24"
                      onClick={() => setShowLastWorkspaceModal(false)}
                    >
                      Exit
                    </Button>
                    <Button
                      className="w-24 bg-red-600 text-white"
                      onClick={sendOTP}
                    >
                      {isLoading ? "Sending..." : "Proceed"}
                    </Button>
                  </div>
                )
              ) : (
                <>
                  <div
                    className="right-pane"
                    style={{
                      flex: "1",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      className="LoginMatCard"
                      style={{
                        width: "90%",
                        maxWidth: "400px",
                        marginTop: "12px",
                      }}
                    >
                      <InputOTP
                        maxLength={6}
                        value={otp}
                        onChange={(value: string) => {
                          setOTP(value);
                          if (value.length === 6) {
                            verifyOTPAndDeleteAccount();
                          }
                        }}
                        autoFocus
                      >
                        <InputOTPGroup>
                          <InputOTPSlot
                            index={0}
                            className="border border-[#E2E8F0]"
                          />
                          <InputOTPSlot
                            index={1}
                            className="border border-[#E2E8F0]"
                          />
                          <InputOTPSlot
                            index={2}
                            className="border border-[#E2E8F0]"
                          />
                        </InputOTPGroup>
                        <InputOTPSeparator />
                        <InputOTPGroup>
                          <InputOTPSlot
                            index={3}
                            className="border border-[#E2E8F0]"
                          />
                          <InputOTPSlot
                            index={4}
                            className="border border-[#E2E8F0]"
                          />
                          <InputOTPSlot
                            index={5}
                            className="border border-[#E2E8F0]"
                          />
                        </InputOTPGroup>
                      </InputOTP>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          textAlign: "center",
                          marginTop: "10px",
                          fontSize: "14px",
                          color: "#000000",
                          fontWeight: 400,
                        }}
                      >
                        Enter your one-time password
                      </Typography>
                      {timer > 0 ? (
                        <Typography
                          variant="body2"
                          sx={{
                            textAlign: "center",
                            color: "#AEAEAE",
                            marginTop: "10px",
                            fontSize: "14px",
                          }}
                        >
                          OTP expires in {Math.floor(timer / 60)}:
                          {timer % 60 < 10 ? `0${timer % 60}` : timer % 60}
                        </Typography>
                      ) : null}
                      {otpError && (
                        <p className="text-red-500 text-xs mt-1 text-center">
                          {otpError}
                        </p>
                      )}
                    </div>
                  </div>

                  {!isImpersonated && (
                    <div className="flex justify-end gap-4 mt-4">
                      <Button
                        variant="outline"
                        className="w-24"
                        onClick={() => {
                          setShowOTPInput(false);
                          setOTP("");
                          setOtpError("");
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="w-28 bg-red-600 text-white"
                        onClick={verifyOTPAndDeleteAccount}
                      >
                        {isLoading ? "Verifying..." : "Verify OTP"}
                      </Button>
                    </div>
                  )}
                </>
              )}
            </DialogContent>
          </Dialog>
        </Card>
        <div className="mb-20" />
      </div>
    </div>
  );
};

export default Workspace_settings;
